import { render } from "./LocalDeliveryRangeModal.vue?vue&type=template&id=c962f36a"
import script from "./LocalDeliveryRangeModal.vue?vue&type=script&lang=js"
export * from "./LocalDeliveryRangeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__